require('./dist/progress-bar/ds6/progress-bar.css');
